import { parsePhoneNumberFromString, PhoneNumber as ParsedPhoneNumber } from "libphonenumber-js"

const defaultCountryCode = "RU"

function groupNumber(parsed: ParsedPhoneNumber) {
    const internationalFormat = parsed.formatInternational()
    if (!internationalFormat) return
    const [code, ...rest] = internationalFormat.split(" ")
    if (!(code && rest?.length)) return
    return `${code}\u2009${rest.join("-")}`
}

interface PhoneNumber {
    raw: string
    isValid: boolean
    internationalFormat?: string
    groupedFormat?: string
}

export function parsePhoneNumber(str: string): PhoneNumber {
    const parsed = parsePhoneNumberFromString(str, defaultCountryCode)
    if (parsed?.isValid()) {
        return {
            raw: str,
            isValid: true,
            internationalFormat: parsed.formatInternational(),
            groupedFormat: groupNumber(parsed) || "",
        }
    }
    return {
        raw: str,
        isValid: false,
    }
}

export function getParsePhoneNumber(str: string) {
    const parsed = parsePhoneNumberFromString(str, defaultCountryCode)
    return parsed?.isValid() ? groupNumber(parsed) || "" : str
}
